import { Controller } from "stimulus";


export default class extends Controller {

  static targets = ["selectableProducts", "autocalcPriceText", "autocalcPriceBasketFeeText"];

  connect() {
    this.updateAutocalcBasketPrice()
  }

  updateAutocalcBasketPrice() {
    var checkedProductsCheckboxes = this.selectableProductsTarget.querySelectorAll("input[type=checkbox]:checked");
    var autocalcPrice = 0.0;
    checkedProductsCheckboxes.forEach((checkbox) => {
      var productID = checkbox.value;
      var productQty = parseInt(document.querySelector(`input#qty_product_${productID}`).value || 1);
      autocalcPrice += (parseFloat(checkbox.dataset.price) * productQty);
    })

    if (autocalcPrice > 0.0) {
      autocalcPrice += 7;
      this.autocalcPriceBasketFeeTextTarget.classList.remove("hidden");
    } else {
      this.autocalcPriceBasketFeeTextTarget.classList.add("hidden");
    }

    this.autocalcPriceTextTarget.innerText = `(${autocalcPrice.toFixed(2).toString().replace(".", ",")} €)`;
  }

  deselectAllProducts(e) {
    e.preventDefault();

    var checkedProductsCheckboxes = this.selectableProductsTarget.querySelectorAll("input[type=checkbox]:checked");
    checkedProductsCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    })

    this.updateAutocalcBasketPrice()
  }

}